import StockSubsectionPlaceholder from "../../../components/StockSubsectionPlaceholder";

export default function ConsumoRealPage() {
  return (
    <StockSubsectionPlaceholder
      sectionPath="analisis"
      subsectionPath="consumo-real"
    />
  );
}
